export const agentsContext = require.context(
  ".",
  true,
  /\_controller.js$/
);
